export default "__VITE_ASSET__9aaaa1ff__"